export const ALERT_TYPES = {
	SUCCESS: "success",
	ERROR: "error",
	WARNING: "warning"
}
